import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Image, FileText, Code, Settings, MessageCircle, Wrench, BookOpen } from 'lucide-react';

const Sidebar = ({ activeTab, setActiveTab }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { id: 'chat', label: 'Chat', icon: MessageCircle, path: '/chat' },
    { id: 'instructions', label: 'Agent Instructions', icon: BookOpen, path: '/instructions' },
    { id: 'api-tools', label: 'API Tools', icon: Wrench, path: '/api-tools' },
    { id: 'logo', label: 'Logo Management', icon: Image, path: '/logo' },
    { id: 'documents', label: 'Document Upload', icon: FileText, path: '/documents' },
    { id: 'widget', label: 'Widget Integration', icon: Code, path: '/widget' },
    { id: 'chat-settings', label: 'Chat Settings', icon: Settings, path: '/chat-settings' },
  ];

  const handleNavigation = (item) => {
    setActiveTab(item.id);
    navigate(item.path);
  };

  return (
    <div className="sidebar">
      <div style={{ padding: '20px', borderBottom: '1px solid #34495e', marginBottom: '20px' }}>
        <h2>Chatbot Admin</h2>
      </div>
      {menuItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path || location.pathname.includes(item.path);
        return (
          <div
            key={item.id}
            className={`nav-item ${isActive ? 'active' : ''}`}
            onClick={() => item.id === 'chat-fullscreen' ? window.open(item.path, '_blank') : handleNavigation(item)}
          >
            <Icon size={20} />
            <span>{item.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default Sidebar;